import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { capitalize } from '@mui/material';
import MopedIcon from '@mui/icons-material/MopedOutlined';
import { Shipment } from '../../../../../../Models';
import { Parcel } from '../../../../../../Models/Cabify';
import { stateMapping } from '../../../../../../utils/shipmentStateMapping';

function ShipmentDetails({ shipment }: { shipment: Shipment | undefined }) {
    const getParcelDetails = (parcel: Parcel) => {
        const receptorDelivery = [
            parcel.status?.delivery_attempt?.id_proof_of_delivery?.recipient_name,
            parcel.status?.delivery_attempt?.id_proof_of_delivery?.recipient_id_number,
        ]
            .filter(Boolean)
            .join(' ');
        const commentPickup = [
            parcel.status?.pickup_attempt?.comment_proof_of_pickup?.comment,
            parcel.status?.pickup_attempt?.feedback,
            parcel.status?.pickup_attempt?.fail_reason,
            parcel.status?.pickup_attempt?.status,
        ]
            .filter(Boolean)
            .join('. ');

        const commentDelivery = [
            parcel.status?.delivery_attempt?.comment_proof_of_delivery?.comment,
            parcel.status?.delivery_attempt?.feedback,
            parcel.status?.delivery_attempt?.fail_reason,
        ]
            .filter(Boolean)
            .join('. ');
        if (
            !parcel?.status?.failure_reason &&
            !commentPickup &&
            !commentDelivery &&
            !receptorDelivery
        ) {
            return null;
        }
        return (
            <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                {parcel?.status?.failure_reason && (
                    <Typography variant="caption">
                        Problema: {parcel.status.failure_reason}
                    </Typography>
                )}
                {commentPickup && (
                    <Stack width="100%">
                        {commentPickup && (
                            <Typography variant="caption">{commentPickup}</Typography>
                        )}
                    </Stack>
                )}
                {(commentDelivery || receptorDelivery) && (
                    <Stack width="100%">
                        {receptorDelivery && (
                            <Typography variant="caption">Receptor: {receptorDelivery}</Typography>
                        )}
                        {commentDelivery && (
                            <Typography variant="caption">{commentDelivery}</Typography>
                        )}
                    </Stack>
                )}
            </Stack>
        );
    };
    if (!shipment) {
        return null;
    }
    const driverInfoName = shipment?.parcels?.[0]?.status?.driver?.name;
    const driverInfoPhone = shipment?.parcels?.[0]?.status?.driver?.phone;
    const wappMessage = encodeURIComponent('Hola, te escribo desde la farmacia');
    return (
        <Stack direction="column">
            <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
                width="100%">
                <Stack
                    direction="row"
                    alignItems="flex-start"
                    justifyContent="space-between"
                    spacing={2}>
                    <Typography variant="body2">
                        {capitalize(`${shipment?.courier}:` || '')} {stateMapping[shipment.state]}
                    </Typography>
                    {shipment?.parcels?.[0]?.status?.tracking?.tracking_url && (
                        <Typography variant="caption">
                            <a
                                href={shipment.parcels[0].status.tracking.tracking_url}
                                target="_blank"
                                rel="noopener noreferrer">
                                Seguimiento
                            </a>
                        </Typography>
                    )}
                    {shipment?.parcels?.[1]?.status?.tracking?.tracking_url && (
                        <Typography variant="caption">
                            <a
                                href={shipment.parcels[1].status.tracking.tracking_url}
                                target="_blank"
                                rel="noopener noreferrer">
                                Vuelta
                            </a>
                        </Typography>
                    )}
                </Stack>
                {(driverInfoName || driverInfoPhone) && (
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        spacing={1}>
                        <MopedIcon />
                        <Typography variant="caption">{driverInfoName}</Typography>
                        <Typography variant="caption">
                            <a
                                target="_blank"
                                href={`https://wa.me/${driverInfoPhone?.replace(/[^0-9]/g, '')}?&text=${wappMessage}`}
                                rel="noreferrer">
                                {driverInfoPhone}
                            </a>
                        </Typography>
                    </Stack>
                )}
            </Stack>
            {!!shipment?.parcels?.[0]?.status && (
                <Stack direction="column">
                    {shipment.parcels.map((parcel, index) => index < 2 && getParcelDetails(parcel))}
                </Stack>
            )}
        </Stack>
    );
}

export default ShipmentDetails;
